import * as leaseDebtSettlementTypes from 'constants/enums/leaseDebtSettlementTypes'

export default {
  [leaseDebtSettlementTypes.DEBT_ACKNOWLEDGEMENT]: 'uznání dluhu',
  [leaseDebtSettlementTypes.INSTALLMENT_PLAN]: 'splátkový kalendář',
  [leaseDebtSettlementTypes.SECURITY]: 'zajištění',
  [leaseDebtSettlementTypes.OTHER]: 'jiné',
}
